import * as angular from 'angular';
import * as c3 from 'c3';
import * as d3 from 'd3';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('pkpRecentAuctionsGraph', pkpRecentAuctionsGraph);

    /**
     * This is a directive for the recent auction activity graph.
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpRecentAuctionsGraph(DATES) {
        return {
            restrict: 'E',
            scope: {
                recentAuctions: '=',
                periodType: '='
            },
            template:
                require('app/_directives/pkp-recent-auctions-graph.directive.html'),
            link: function postLink(scope, iElement) {
                scope.DATES = DATES;
                var graphData = buildGraphData(scope.recentAuctions);

                var maxs = 0;
                for (var j = 0; j < graphData.scene.length; j++) {
                    if (
                        angular.isUndefined(graphData.scene[j].Requested) ||
                        scope.periodType !== 'DAY'
                    ) {
                        var maxtemp = 0;
                        maxtemp = Math.max(
                            graphData.scene[j].Marketable,
                            graphData.scene[j].Marketed
                        );
                    } else {
                        maxtemp = Math.max(
                            graphData.scene[j].Marketable,
                            graphData.scene[j].Marketed,
                            graphData.scene[j].Requested
                        );
                    }
                    maxs = Math.max(maxs, maxtemp);
                }

                var chart = buildGraph(
                    $(iElement[0]).children()[0],
                    graphData,
                    maxs,
                    scope.periodType
                );

                //watch parent width, to use the right size for the graph.
                var unbindParentElemWidthWatcher = scope.$watch(
                    function () {
                        try {
                            return iElement.parent().width();
                        } catch (E) {}
                    },
                    function (width) {
                        if (!width || width <= 0) {
                            return;
                        }

                        chart.resize();
                        unbindParentElemWidthWatcher();
                    }
                );
            }
        };

        function buildGraphData(auctions) {
            var chartData = {
                scene: [],
                variables: {}
            };
            angular.forEach(auctions, function (auction) {
                var scene: any = {
                    label: auction.label,
                    Marketable: auction.marketable.value.value,
                    Marketed: auction.marketed.value.value
                };
                if (!angular.isUndefined(auction.requested)) {
                    scene.Requested = auction.requested.value.value;
                }
                chartData.scene.push(scene);
            });
            chartData.variables = {
                unit: 'kWh/h'
            };

            return chartData;
        }

        /*        function formattingLabel(label, typ){

        }*/

        function buildGraph(elem, graphData, maxs, typ) {
            var keys = ['Marketable', 'Marketed', 'Requested'];
            if (typ !== 'DAY') {
                keys = ['Marketable', 'Marketed'];
            }
            var c3Graph = c3.generate({
                bindto: elem,
                data: {
                    json: graphData.scene,
                    selection: {
                        enabled: false
                    },
                    keys: {
                        x: 'label',
                        value: keys
                    },
                    types: {
                        Marketable: 'area'
                    },
                    colors: {
                        Marketable: '#418bca',
                        Marketed: '#333399',
                        Requested: '#00888A'
                    }
                },
                legend: {
                    hide: true
                },
                point: {
                    show: false,
                    focus: {
                        expand: {
                            enabled: true
                        }
                    }
                },
                axis: {
                    x: {
                        type: 'category'
                    },
                    y: {
                        show: false,
                        min: 0,
                        padding: {
                            bottom: 0
                        },
                        tick: {
                            values: [0, maxs],
                            format: function (d) {
                                return (
                                    d3.format(',3f')(d) +
                                    ' ' +
                                    graphData.variables.unit
                                );
                            }
                        }
                    }
                },
                tooltip: {
                    contents: function (
                        d,
                        defaultTitleFormat,
                        defaultValueFormat,
                        color
                    ) {
                        var $$ = this,
                            config = $$.config,
                            CLASS = $$.CLASS,
                            titleFormat =
                                config.tooltip_format_title ||
                                defaultTitleFormat,
                            nameFormat =
                                config.tooltip_format_name ||
                                function (name) {
                                    return name;
                                },
                            valueFormat =
                                config.tooltip_format_value ||
                                defaultValueFormat,
                            text,
                            i,
                            title,
                            value,
                            name,
                            bgcolor;
                        //var count = 0;
                        for (i = 0; i < d.length; i++) {
                            if (!(d[i] && (d[i].value || d[i].value === 0))) {
                                continue;
                            }
                            if (!text) {
                                title = graphData.scene[d[i].index].label;
                                text =
                                    "<table class='" +
                                    CLASS.tooltip +
                                    "'>" +
                                    (title || title === 0
                                        ? "<tr><th colspan='2'>" +
                                          title +
                                          '</th></tr>'
                                        : '');
                            }
                            name = nameFormat(d[i].name);
                            value = valueFormat(
                                d[i].value,
                                d[i].ratio,
                                d[i].id,
                                d[i].index
                            );
                            bgcolor = $$.levelColor
                                ? $$.levelColor(d[i].value)
                                : color(d[i].id);
                            text +=
                                "<tr class='" +
                                CLASS.tooltipName +
                                '-' +
                                d[i].id +
                                "'>";
                            text += `<td class="name"><span ng-style="{ 'background-color': '${bgcolor}', 'border-radius': '5px' }"></span>${name}</td>`;
                            text += "<td class='value'>" + value + '</td>';
                            text += '</tr>';
                        }
                        return text;
                    }
                }
            });

            return c3Graph;
        }
    }
})();
